import { create } from 'zustand';
import type { Connection } from '../../../types/electron';

interface ConnectionsUIState {
  // Dialog visibility
  showNewConnectionDialog: boolean;
  prefillHandoffId: string | null;
  showConnectionsDialog: boolean;
  /**
   * Connection whose edit dialog should be open, opened from surfaces that
   * live outside the Saved Connections dialog (command palette). The Saved
   * Connections dialog keeps its own local editing state — this is only for
   * jumping straight into one connection's edit form.
   */
  editingConnection: Connection | null;

  // Actions
  setShowNewConnectionDialog: (show: boolean, prefillHandoffId?: string | null) => void;
  acknowledgePrefillHandoff: (handoffId: string) => void;
  setShowConnectionsDialog: (show: boolean) => void;
  setEditingConnection: (connection: Connection | null) => void;
}

export const useConnectionsUIStore = create<ConnectionsUIState>((set) => ({
  // Initial state
  showNewConnectionDialog: false,
  prefillHandoffId: null,
  showConnectionsDialog: false,
  editingConnection: null,

  // Actions
  // Opening either connections dialog clears any pending palette-opened edit:
  // App.tsx suppresses the edit host while these dialogs are up (they own
  // their local edit flows), so a latched `editingConnection` would otherwise
  // pop a ghost edit dialog the moment the other dialog closes.
  setShowNewConnectionDialog: (show, prefillHandoffId = null) =>
    set(show ? { showNewConnectionDialog: true, prefillHandoffId, editingConnection: null } : { showNewConnectionDialog: false, prefillHandoffId: null }),
  acknowledgePrefillHandoff: (handoffId) => set((state) => state.prefillHandoffId === handoffId ? { prefillHandoffId: null } : state),
  setShowConnectionsDialog: (show: boolean) =>
    set(show ? { showConnectionsDialog: true, editingConnection: null } : { showConnectionsDialog: false }),
  setEditingConnection: (connection: Connection | null) => set({ editingConnection: connection }),
}));
